import SectionTracker from './section-tracker';
import trackingJson from './tracking';
import { siteName, lang } from 'pageMeta/pageMeta';

const setCustomTrackingVars = function (trackObj, $el) {
    const pageName = siteName;

    // Replace any variables within each prop value.
    for (const prop in trackObj) {
        if (trackObj.hasOwnProperty(prop)) {
            let value = trackObj[prop].toString();

            if (value.indexOf('@') !== -1) {
                if (value.match(/@PAGE_NAME@/)) {
                    value = value.replace(/@PAGE_NAME@/, pageName);
                }

                if (value.match(/@LANG@/)) {
                    const appLang = lang || 'en';
                    value = value.replace(/@LANG@/, appLang);
                }

                if (value.match(/@GAME_DATE@/)) {
                    let gameDate = $('.sns-daypicker').find('.selected button').attr('aria-label');
                    value = value.replace(/@GAME_DATE@/, gameDate);
                }

                if (value.match(/@SCHEDULE_AWAY_CLUB_NAME@/)) {
                    const $parent = $($el).closest('div:has(*[data-mlb-test="scoreOrState"])');
                    const awayName = $parent.find('div:has(*[data-mlb-test="teamNameLabel"])').find('.fdaoCu:last').first().text();
                    value = value.replace(/@SCHEDULE_AWAY_CLUB_NAME@/, awayName);
                }

                if (value.match(/@SCHEDULE_HOME_CLUB_NAME@/)) {
                    const $parent = $($el).closest('div:has(*[data-mlb-test="scoreOrState"])');
                    const homeName = $parent.find('div:has(*[data-mlb-test="teamNameLabel"])').find('.fdaoCu').last().text();
                    value = value.replace(/@SCHEDULE_HOME_CLUB_NAME@/, homeName);
                }

                if (value.match(/@SCORES_AWAY_CLUB_NAME@/)) {
                    const $parent = $($el).closest('div.btOCDf');
                    const awayName = $parent.find('.gIrSBh').find('.fdaoCu').first().text();
                    value = value.replace(/@SCORES_AWAY_CLUB_NAME@/, awayName);
                }

                if (value.match(/@SCORES_HOME_CLUB_NAME@/)) {
                    const $parent = $($el).closest('div.btOCDf');
                    const homeName = $parent.find('.gIrSBh').find('.fdaoCu').last().text();
                    value = value.replace(/@SCORES_HOME_CLUB_NAME@/, homeName);
                }

                if (value.match(/@SCORES_AWAY_CLUB_NAME_MOBILE@/)) {
                    const awayName = $($el).find('.fdaoCu').first().text();
                    value = value.replace(/@SCORES_AWAY_CLUB_NAME_MOBILE@/, awayName);
                }

                if (value.match(/@SCORES_HOME_CLUB_NAME_MOBILE@/)) {
                    const homeName = $($el).find('.fdaoCu').last().text();
                    value = value.replace(/@SCORES_HOME_CLUB_NAME_MOBILE@/, homeName);
                }

                if (value.match(/@GAME_STATUS@/)) {
                    const $parent = $($el).closest('div.gPLsYH');
                    const gameStatus = $parent.find('.feaLYF').text();
                    value = value.replace(/@GAME_STATUS@/, gameStatus);
                }

                if (value.match(/@PLAYER_ID@/)) {
                    const $href = $($el).attr('href');
                    const parseHref = $href.split('-');
                    const playerId = parseHref[parseHref.length - 1];
                    value = value.replace(/@PLAYER_ID@/, playerId);
                }

                if (value.match(/@TEAM_NAME@/)) {
                    const $href = $($el).attr('href');
                    const parseHref = $href.split('/');
                    const teamNAME = parseHref[parseHref.length - 1];
                    value = value.replace(/@TEAM_NAME@/, teamNAME);
                }

                trackObj[prop] = value;
            }

            // Remove any bad props.
            if (trackObj[prop] === 'undefined' || trackObj[prop] === null) {
                delete trackObj[prop];
            }
        }
    }

    return trackObj;
};

export default function () {
    const sectionTracker = new SectionTracker(trackingJson, setCustomTrackingVars, {});
    sectionTracker.init();
}
